import { Card } from '@employ-engage/common-components';
import { useState } from 'react';
import { Button } from '@employ-engage/common-components';
import { ExportDataModal } from '../export-data-modal/export-data-modal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/* eslint-disable-next-line */
export interface ReportsPageProps {}

export function ReportsPage(props: ReportsPageProps) {
  const { t } = useTranslation(['common']);
  const [isExportDataModalOpen, setIsExportDataModalOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="mt-10">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
          {t('Reports')}
        </h1>
      </div>
      <div className="grid grid-cols-6 lg:grid-cols-12 gap-5">
        <Card className="col-span-12 lg:col-span-6 flex flex-col items-center justify-center gap-3 text-center">
          <p className="text-sm text-light-secondaryText dark:text-dark-secondaryText">
            {t('See how people answered each question, broken down as you like.')}
          </p>
          <Button variant="primary" onClick={() => navigate('report-builder')}>
            {t('View Survey Results')}
          </Button>
        </Card>
        <Card className="col-span-12 lg:col-span-6 flex flex-col items-center justify-center gap-3 text-center">
          <p className="text-sm text-light-secondaryText dark:text-dark-secondaryText">
            {t('Download the raw responses to work with elsewhere.')}
          </p>
          <Button
            variant="primary"
            onClick={() => setIsExportDataModalOpen(true)}
          >
            {t('Run Data Export')}
          </Button>
        </Card>
      </div>
      <ExportDataModal
        open={isExportDataModalOpen}
        setOpen={setIsExportDataModalOpen}
      />
    </div>
  );
}

export default ReportsPage;
